export const ContainerTypes = {
    '':'',
    _20FT : "20' STANDARD CONTAINER",
    _40FT : "40' STANDARD CONTAINER",
    _40HC : "40' HIGH CUBE CONTAINER",
    _45GP : "45' GENERAL PURPOSE CONTAINER",
    _45HC : "45' HIGH CUBE CONTAINER",
    _20DR : "20' DRY REEFER CONTAINER",
    _20FC : "20' FLEXIBAG CONTAINER",
    _20FG : "20' FOOD GRADE CONTAINER",
    _20FR : "20' FLAT RACK CONTAINER",
    _20GH : "20' GARMENT ON HANGER CONTAINER",
    _20HC : "20' HIGH CUBE CONTAINER",
    _20HD : "20' H/D REEFER CONTAINER",
    _20IT : "20' ISO TANK",
    _20OT : "20' OPEN TOP CONTAINER",
    _20PF : "20' PLATFORMS",
    _20RF : "20' REEFER CONTAINER",
    _20RH : "20' HIGH CUBE REEFER CONTAINER",
    _20SL : "20' SLIDING OPEN CONTAINER",
    _40DR : "40' DRY REEFER",
    _40FG : "40' FOOD GRADE CONTAINER",
    _40FR : "40' FLAT RACK CONTAINER",
    _40GH : "40' GARMENT ON HANGER CONTAINER",
    _40HF : "40' HIGH CUBE FLAT RACK",
    _40HH : "40' HIGH CUBE HANGER CONTAINER",
    _40HL : "40' HALF-HEIGHT OPEN TOP CONTAINER",
    _40HR : "40' HIGH CUBE DRY REEFER CONTAINER",
    _40HS : "40' HC SUBSTITUTE 40GP",
    _40IN : "40' INSULATED CONTAINER",
    _40OT : "40' OPEN TOP CONTAINER",
    _40RF : "40' REEFER CONTAINER",
    _40RH : "40' REEFER HIGH-CUBE CNTR",
    _40RQ : "40' CUBE REEFER CONTAINER",
    _40TK : "40' TANK",
    _45DR : "45' DRY REEFER CONTAINER",
    _45FR : "45' FLAT RACK",
    _45HD : "45' HIGH CUBE DRY REEFER CONTAINER",
    _45HT : "45' HANGER CONTAINER",
    _45RF : "45' REEFER CONTAINER",
    _45RH : "45' HIGH CUBE REEFER CONTAINER",
    _45TR : "45' TRAILER",
    _48HC : "48' HIGH CUBE CONTAINER",
    _48TR : "48' TRAILER",
    _53HC : "53' HIGH CUBE CONTAINER",
    _53TR : "53' TRAILER",
    _BBLK : "BREAK BULK",
    _RORO : "ROLLON. ROLLOFF"
}